module.exports = __webpack_public_path__ + "img/Butterfly_00122.95a84db6.png";